import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ProductService } from '@core/product/product.service';
import { AuthService } from '@features/auth/auth.service';

export const authPagesGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const authS = inject(AuthService);

    const isLoggedIn = authS.isUserLogged();
    if (isLoggedIn) {
        router.navigateByUrl(inject(ProductService).homeUrl());
        return false;
    }
    return true;
};
